import { render } from "./IconOrangeQuestionMark.vue?vue&type=template&id=57fdacb8"
import script from "./IconOrangeQuestionMark.vue?vue&type=script&lang=js"
export * from "./IconOrangeQuestionMark.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__